import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, SelectField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import { hasElements } from "utils/arrays";
import Icon from "components/common_components/Icon";
import currencies from "utils/static/currencies";
import { MenuItem } from "@material-ui/core";
import { formatCurrency } from "utils/currency";

function Form({ data, mode, ...rest }) {
    const validationSchema = Yup.object(
        hasElements(data) ? data.reduce((map, obj) => ({ ...map, [obj.id]: Yup.string().required("Required field") }), {}) : {}
    );

    const initialValues = hasElements(data) ? data.reduce((map, obj) => ({ ...map, [obj.id]: obj.value }), {}) : {};

    return (
        <FormikForm initialValues={initialValues} validationSchema={validationSchema} {...rest} showButtons={mode === "update"}>
            {(form) => (
                <div className="layout">
                    <Grid container spacing={1}>
                        {hasElements(data) &&
                            data.map((configuration) => {
                                const { id, name, type, description } = configuration;
                                return (
                                    <Fragment key={`item-${id}`}>
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}
                                            style={{ cursor: "help", display: "flex", alignItems: "center", gap: 10 }}
                                            title={`${name}\n\n${description}`}
                                        >
                                            <strong>{name}</strong>
                                            <Icon name="question" size="xs" color="secondary" />
                                        </Grid>
                                        <Grid item md={6} xs={12} style={{ display: "flex", alignItems: "center" }}>
                                            {type === "number" && <InputField disabled={mode === "view"} fieldName={id} numeric label="" />}
                                            {type === "boolean" && (
                                                <SelectField
                                                    disabled={mode === "view"}
                                                    fieldName={id}
                                                    options={[
                                                        { value: "true", label: "Yes" },
                                                        { value: "false", label: "No" },
                                                    ]}
                                                />
                                            )}
                                            {type === "string" && <InputField disabled={mode === "view"} fieldName={id} />}
                                            {type === "currency" && (
                                                <SelectField
                                                    disabled={mode === "view"}
                                                    fieldName={id}
                                                    label="Select a currency"
                                                    valueKey={"isoCode"}
                                                    labelKey={"name"}
                                                    helperText={`E.g. ${formatCurrency(
                                                        5000000,
                                                        currencies.find((x) => x.isoCode === form.values[id])?.locale,
                                                        form.values[id]
                                                    )}`}
                                                    renderOption={(option) => (
                                                        <MenuItem key={option.isoCode} value={option.isoCode}>
                                                            {`${option.isoCode} - (${option.symbol})  -  ${option.name}`}
                                                        </MenuItem>
                                                    )}
                                                    options={currencies}
                                                />
                                            )}
                                        </Grid>
                                    </Fragment>
                                );
                            })}
                    </Grid>
                </div>
            )}
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            value: PropTypes.string,
            name: PropTypes.string,
            type: PropTypes.oneOf(["string", "number", "boolean", "currency"]),
            description: PropTypes.string,
        })
    ),
    mode: PropTypes.oneOf(["update", "view"]).isRequired,
};

Form.defaultProps = {
    data: [],
    mode: "view",
};

export default Form;
